import { render, staticRenderFns } from "./CreateEditSector.vue?vue&type=template&id=b2411464&"
import script from "./CreateEditSector.vue?vue&type=script&lang=js&"
export * from "./CreateEditSector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports